import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/user-preferences/store';
import { CssTextField } from 'components/select';

const BusinessJustification = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);

    const handleChange = (event) => {
        setOrder({
            ...order,
            businessJustification: event.target.value,
        });
    };

    const validateInput = () => {
        if ((isTouched && order?.isTouched && !order?.businessJustification) || isTouched) {
            return 'validate';
        }
        return '';
    };

    React.useEffect(() => {
        if (!order?.businessJustification && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.businessJustification, order?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <CssTextField
                size="small"
                label="Business Justification *"
                value={order?.businessJustification || ''}
                onChange={handleChange}
                className={validateInput()}
                fullWidth
                multiline
                rows={4}
                data-testid="business-justification"
                placeholder="Enter business justification"
            />
        </Box>
    );
};

export default React.memo(BusinessJustification);
